<div class="container-modal">

  @if (clientNotificationList.length + serverNotificationList.length === 0) {
    <div class="empty">
      <div>{{'common.emptyNotification' |translate}}</div>
    </div>
  }

  @if (serverNotificationList.length > 0) {
    <div class="table">
      <h4>System Messages:</h4>
      <p-table [value]="serverNotificationList">
        <ng-template pTemplate="body" let-notif>
          <tr class="nText">
            <td [attr.colspan]="'2'">{{notif.message}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  @if (clientNotificationList.length > 0) {
    <div class="table">
      @if (clientNotificationList.length > 0) {
        <div class="button-cont">
          <button (click)="clearClientNotifications()" class="btn-custom">{{'clear'| translate}}</button>
        </div>
      }
      <h4>Application Events:</h4>
      <p-table [value]="clientNotificationList">
        <ng-template pTemplate="body" let-notif>
          <tr class="nText">
            <td [ngClass]="notif.date !== null ? 'message' : ''" [attr.colspan]="notif.date !== null ? '1' : '2'">{{notif.message}}</td>
            @if (notif.date !== null) {
              <td class="date">{{notif.date | date: 'dd-MMM-yyyy h:mm:ss'}}</td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
